import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type StreamLiveGuestRidesSubscriptionVariables = Types.Exact<{
  cursor: Array<Types.InputMaybe<Types.Guestrides_Stream_Cursor_Input>> | Types.InputMaybe<Types.Guestrides_Stream_Cursor_Input>;
  where: Types.Guestrides_Bool_Exp;
}>;


export type StreamLiveGuestRidesSubscription = { __typename?: 'subscription_root', guestrides_stream: Array<{ __typename?: 'guestrides', id: number, status: string, guest_name: string, guest_phone: string, pickup_address?: string | null, pickup_lat: number, pickup_lng: number, dropoff_address?: string | null, dropoff_lat: number, dropoff_lng: number, provider?: string | null, notes?: string | null, config: object, customer_id: number, created_at: string, created_by?: string | null, updated_at: string, updated_by?: string | null, ridehails: Array<{ __typename?: 'ridehails', id: number, status?: string | null, provider?: string | null, driver_name?: string | null, driver_phone?: string | null, driver_photo_url?: string | null, pickup_address?: string | null, dropoff_address?: string | null, pickup_at?: string | null, dropoff_at?: string | null, estimated_price?: number | null, actual_price?: number | null, created_at: string, updated_at: string, external_id?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_color?: string | null, vehicle_year?: number | null, vehicle_license_plate?: string | null, vehicle_photo_url?: string | null, quality_rejection_reason?: string | null, tracking_link?: string | null }> }> };


export const StreamLiveGuestRidesDocument = gql`
    subscription StreamLiveGuestRides($cursor: [guestrides_stream_cursor_input]!, $where: guestrides_bool_exp!) {
  guestrides_stream(cursor: $cursor, batch_size: 50, where: $where) {
    id
    status
    guest_name
    guest_phone
    pickup_address
    pickup_lat
    pickup_lng
    dropoff_address
    dropoff_lat
    dropoff_lng
    provider
    notes
    config
    customer_id
    created_at
    created_by
    updated_at
    updated_by
    ridehails(order_by: {created_at: desc}, limit: 1) {
      id
      status
      provider
      driver_name
      driver_phone
      driver_photo_url
      pickup_address
      dropoff_address
      pickup_at
      dropoff_at
      estimated_price
      actual_price
      created_at
      updated_at
      external_id
      vehicle_make
      vehicle_model
      vehicle_color
      vehicle_year
      vehicle_license_plate
      vehicle_photo_url
      quality_rejection_reason
      tracking_link
    }
  }
}
    `;

/**
 * __useStreamLiveGuestRidesSubscription__
 *
 * To run a query within a React component, call `useStreamLiveGuestRidesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStreamLiveGuestRidesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStreamLiveGuestRidesSubscription({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useStreamLiveGuestRidesSubscription(baseOptions: Apollo.SubscriptionHookOptions<StreamLiveGuestRidesSubscription, StreamLiveGuestRidesSubscriptionVariables> & ({ variables: StreamLiveGuestRidesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<StreamLiveGuestRidesSubscription, StreamLiveGuestRidesSubscriptionVariables>(StreamLiveGuestRidesDocument, options);
      }
export type StreamLiveGuestRidesSubscriptionHookResult = ReturnType<typeof useStreamLiveGuestRidesSubscription>;
export type StreamLiveGuestRidesSubscriptionResult = Apollo.SubscriptionResult<StreamLiveGuestRidesSubscription>;